import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  // Separate from the default spinner that pages show/hide by hand, so a page's own hide() can't
  // close the overlay while API calls are still running (see <ngx-spinner name="api"> in app.component.html)
  static readonly API_SPINNER = 'api';

  private subject = new Subject<{ name: string, action: string }>();
  private spins: string[] = [];

  constructor(
    private spinner: NgxSpinnerService,
  ) {
    this.subject.subscribe(({ name, action }) => {
      if (action == "add") {
        this.spins.push(name);
        this.spinner.show(SpinnerService.API_SPINNER);
      }
      else {
        this.spins = this.spins.filter(spin => spin !== name);
        if (this.spins.length === 0) {
          this.spinner.hide(SpinnerService.API_SPINNER);
        }
      }
    });
  }

  public add(name: string) {
    this.subject.next({ name: name, action: "add" });
  }

  public stop(name: string) {
    this.subject.next({ name: name, action: "remove" });
  }

}
